/**
 * Defines the upcoming calendar schedule
 * @remarks This defines a month which is not yet released, but will soon be released.
 */
export default class CalendarSchedule {
  /**
   * The start of the calendar schedule
   */
  startDate: Date;
  /**
   * The end of the calendar schedule
   */
  endDate: Date;
  /**
   * Specifies the date when the calendar will be made available to the residents
   */
  releaseDate: Date;

  constructor(startDate: Date, endDate: Date, releaseDate: Date) {
    this.startDate = startDate;
    this.endDate = endDate;
    this.releaseDate = releaseDate;
  }
}
